import type { ComponentClass } from 'react';

import { usePostHog } from 'posthog-js/react';

export default function withPosthog<T extends ComponentClass<any, any>>(Component: T) {
    return function WrappedComponent(props) {
        const posthog = usePostHog();
        return <Component {...props} posthog={posthog} />;
    };
}
